export const WAVE_1_CITIES = [
  "New York", "Los Angeles", "Chicago", "Houston", "Phoenix",
  "Philadelphia", "San Antonio", "San Diego", "Dallas", "San Jose",
  "Austin", "Jacksonville", "Fort Worth", "Columbus", "Indianapolis",
  "Charlotte", "San Francisco", "Seattle", "Denver", "Nashville"
];

export const WAVE_2_CITIES = [
  ...WAVE_1_CITIES,
  "Oklahoma City", "El Paso", "Washington", "Boston", "Memphis",
  "Portland", "Las Vegas", "Louisville", "Baltimore", "Milwaukee",
  "Albuquerque", "Tucson", "Fresno", "Sacramento", "Mesa",
  "Kansas City", "Atlanta", "Omaha", "Colorado Springs", "Raleigh",
  "Long Beach", "Virginia Beach", "Miami", "Oakland", "Minneapolis",
  "Tampa", "Tulsa", "Arlington", "New Orleans", "Wichita"
];

export const WAVE_3_CITIES = [
  ...WAVE_2_CITIES,
  "Cleveland", "Bakersfield", "Aurora", "Anaheim", "Honolulu",
  "Santa Ana", "Riverside", "Corpus Christi", "Lexington", "Henderson",
  "Stockton", "Saint Paul", "Cincinnati", "St. Louis", "Pittsburgh",
  "Greensboro", "Lincoln", "Anchorage", "Plano", "Orlando",
  "Irvine", "Newark", "Durham", "Chula Vista", "Toledo",
  "Fort Wayne", "St. Petersburg", "Laredo", "Jersey City", "Chandler",
  "Madison", "Lubbock", "Gilbert", "Reno", "Buffalo",
  "North Las Vegas", "Winston-Salem", "Chesapeake", "Norfolk", "Fremont",
  "Garland", "Irving", "Hialeah", "Richmond", "Boise",
  "Spokane", "Baton Rouge", "Des Moines", "Tacoma", "San Bernardino"
];

export const SALARY_LEVELS = [40, 50, 60, 70, 80, 90, 100, 120, 150, 200];
